function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Brands, logoDefaultValues } from './logo';
import { FontFamilyBrands, typographyDefaultValues } from './typography';
import { IconsBrands, iconsDefaultValues } from './icons';
import { Tokens as BorderRadiusTokens } from '../themes/default/borderRadius';
import { Tokens as BorderWidthTokens } from '../themes/default/borderWidth';
import PropTypes from 'prop-types';
import React from 'react';
import { Tokens as ShapeTokens } from '../themes/default/shape';
import { Tokens as SpacingTokens } from '../themes/default/spacing';
import borderRadiusValues from './borderRadius';
import borderWidthValues from './borderWidth';
import colorsValues from './colors';
import { modalDefaultValues } from './modal';
import shapeValues from './shape';
import spacingValues from './spacing'; // Border Radius Updates

var borderRadiusTokens = Object.keys(BorderRadiusTokens);

var themeBorderRadius = function themeBorderRadius() {
  var borderRadiusOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedBorderRadius = _objectSpread({}, borderRadiusValues);

  Object.keys(borderRadiusOverrides).forEach(function (borderRadiusName) {
    if (borderRadiusTokens.indexOf(borderRadiusName) === -1) {
      if (typeof borderRadiusOverrides[borderRadiusName] === 'number') {
        themedBorderRadius[borderRadiusName] = borderRadiusOverrides[borderRadiusName];
      } else {
        /* eslint-disable no-console */
        console.error("Border Radius override must be a number - ignoring ".concat(borderRadiusName, " override"));
      }
    } else {
      console.error("User may not override Border Radius Tokens: ".concat(borderRadiusTokens, " - ignoring ").concat(borderRadiusName, " override"));
    }
  });
  return themedBorderRadius;
}; // Border Width Updates


var borderWidthTokens = Object.keys(BorderWidthTokens);

var themeBorderWidth = function themeBorderWidth() {
  var borderWidthOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedBorderWidth = _objectSpread({}, borderWidthValues);

  Object.keys(borderWidthOverrides).forEach(function (borderWidthName) {
    if (borderWidthTokens.indexOf(borderWidthName) === -1) {
      if (typeof borderWidthOverrides[borderWidthName] === 'number') {
        themedBorderWidth[borderWidthName] = borderWidthOverrides[borderWidthName];
      } else if (borderWidthOverrides[borderWidthName] === BorderWidthTokens.Thin) {
        themedBorderWidth[borderWidthName] = 1;
      } else {
        /* eslint-disable no-console */
        console.error("Border Width override must be a number or one of the values in BorderWidth Tokens - ignoring ".concat(borderWidthName, " override"));
      }
    } else {
      console.error("User may not override Border Width Tokens: ".concat(borderWidthTokens, " - ignoring ").concat(borderWidthName, " override"));
    }
  });
  return themedBorderWidth;
}; // Color Updates


var themeColors = function themeColors() {
  var colorOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedColors = _objectSpread({}, colorsValues);

  Object.keys(colorOverrides).forEach(function (colorName) {
    if (colorName.indexOf('System') !== 0 && colorName.indexOf('Brand') !== 0) {
      if (colorOverrides[colorName][0] === '#' && colorOverrides[colorName].length === 7) {
        themedColors[colorName] = colorOverrides[colorName];
      } else if (colorsValues[colorOverrides[colorName]]) {
        themedColors[colorName] = colorsValues[colorOverrides[colorName]];
      } else {
        console.error("Colors override must be a Colors Token name or a six digit hex color code - ignoring ".concat(colorName, " override"));
      }
    } else {
      console.error("User may not override System or Brand Color Tokens - ignoring ".concat(colorName, " override"));
      /* eslint-enable no-console */
    }
  });
  return themedColors;
}; // Icons Updates


var themeIcons = function themeIcons() {
  var iconsOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedIcons = _objectSpread({}, iconsDefaultValues);

  if (iconsOverrides && Object.values(IconsBrands).includes(iconsOverrides.Brand)) {
    themedIcons.Brand = iconsOverrides.Brand;
  }

  return themedIcons;
}; // Logo Updates


var themeLogo = function themeLogo() {
  var logoOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedLogo = _objectSpread({}, logoDefaultValues);

  if (logoOverrides && Object.values(Brands).includes(logoOverrides.Brand)) {
    themedLogo.Brand = logoOverrides.Brand;
  }

  return themedLogo;
}; // Shape Updates


var themeShape = function themeShape() {
  var shapeOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedShape = _objectSpread({}, shapeValues);

  var shapeTokens = Object.keys(ShapeTokens);
  var validShapeValues = Object.values(ShapeTokens);
  Object.keys(shapeOverrides).forEach(function (shapeName) {
    if (shapeTokens.indexOf(shapeName) === -1) {
      if (validShapeValues.indexOf(shapeOverrides[shapeName]) > -1) {
        themedShape[shapeName] = shapeOverrides[shapeName];
      } else {
        /* eslint-disable no-console */
        console.error("Shape override must be one of the values in Shape Tokens - ignoring ".concat(shapeName, " override"));
      }
    } else {
      console.error("User may not override Shape Tokens: ".concat(Object.keys(ShapeTokens), " - ignoring ").concat(shapeName, " override"));
    }
  });
  return themedShape;
}; // Spacing Updates


var themeSpacing = function themeSpacing() {
  var spacingOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedSpacing = _objectSpread({}, spacingValues);

  var shapeTokens = Object.keys(SpacingTokens);
  Object.keys(spacingOverrides).forEach(function (spacingName) {
    if (shapeTokens.indexOf(spacingName) === -1) {
      if (typeof spacingOverrides[spacingName] === 'number') {
        themedSpacing[spacingName] = spacingOverrides[spacingName];
      } else {
        /* eslint-disable no-console */
        console.error("Spacing override must be a number - ignoring ".concat(spacingName, " override"));
      }
    } else {
      console.error("User may not override Spacing Tokens: ".concat(Object.keys(SpacingTokens), " - ignoring ").concat(spacingName, " override"));
    }
  });
  return themedSpacing;
}; // Typography Updates


var themeTypography = function themeTypography() {
  var typographyOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedTypography = _objectSpread({}, typographyDefaultValues);

  Object.keys(typographyOverrides).forEach(function (typographyName) {
    // Users can also pass in a supported Brand name (like "DoorDash" or "Caviar")
    // and this block will map it to the correct font family
    if (typographyName === 'FontFamily' && FontFamilyBrands[typographyOverrides[typographyName]]) {
      themedTypography[typographyName] = FontFamilyBrands[typographyOverrides[typographyName]];
    } else {
      themedTypography[typographyName] = typographyOverrides[typographyName];
    }
  });
  return themedTypography;
}; // Additional Updates


var themeUpdate = function themeUpdate(themeDefaults) {
  var themeOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var themeUpdates = _objectSpread({}, themeDefaults);

  Object.keys(themeOverrides).forEach(function (key) {
    themeUpdates[key] = themeOverrides[key];
  });
  return themeUpdates;
}; // Theming Exports


var ThemingContext = React.createContext({
  BorderRadius: borderRadiusValues,
  BorderWidth: borderWidthValues,
  Colors: colorsValues,
  Icons: iconsDefaultValues,
  Logo: logoDefaultValues,
  Modal: modalDefaultValues,
  Shape: shapeValues,
  Spacing: spacingValues,
  Typography: typographyDefaultValues
});

var Theming = function Theming(_ref) {
  var children = _ref.children,
      overrides = _ref.overrides;
  return React.createElement(ThemingContext.Provider, {
    value: {
      BorderRadius: overrides && themeBorderRadius(overrides.BorderRadius),
      BorderWidth: overrides && themeBorderWidth(overrides.BorderWidth),
      Colors: overrides && themeColors(overrides.Colors),
      Icons: overrides && themeIcons(overrides.Icons),
      Logo: overrides && themeLogo(overrides.Logo),
      Modal: overrides && themeUpdate(modalDefaultValues, overrides.Modal),
      Shape: overrides && themeShape(overrides.Shape),
      Spacing: overrides && themeSpacing(overrides.Spacing),
      Typography: overrides && themeTypography(overrides.Typography)
    }
  }, children);
};

var ThemingConsumer = function ThemingConsumer(_ref2) {
  var children = _ref2.children;
  return React.createElement(ThemingContext.Consumer, null, children);
};

var withTheming = function withTheming(Comp) {
  return function (props) {
    var theme = React.useContext(ThemingContext);
    return React.createElement(Comp, _extends({
      theme: theme
    }, props));
  };
};

ThemingConsumer.propTypes = {
  children: PropTypes.func
};
Theming.propTypes = {
  children: PropTypes.node,
  overrides: PropTypes.object
};
export { Theming, ThemingConsumer, ThemingContext, withTheming };